import React from 'react';

const EditIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_256_8517)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.8991 2.73229C13.0142 2.6171 13.1705 2.55239 13.3334 2.55239C13.4963 2.55239 13.6525 2.6171 13.7677 2.73229C13.8829 2.84748 13.9476 3.00371 13.9476 3.16661C13.9476 3.32951 13.8829 3.48573 13.7677 3.60092L7.59104 9.77757L6.43287 10.0671L6.72241 8.90894L12.8991 2.73229ZM13.3334 0.952393C12.7461 0.952393 12.1829 1.18568 11.7677 1.60092L5.43435 7.93425C5.33183 8.03678 5.25909 8.16525 5.22393 8.30591L4.55726 10.9726C4.4891 11.2452 4.56898 11.5336 4.76769 11.7323C4.96639 11.931 5.25478 12.0109 5.5274 11.9427L8.19407 11.2761C8.33473 11.2409 8.4632 11.1682 8.56572 11.0656L14.8991 4.73229C15.3143 4.31705 15.5476 3.75385 15.5476 3.16661C15.5476 2.57936 15.3143 2.01617 14.8991 1.60092C14.4838 1.18568 13.9206 0.952393 13.3334 0.952393ZM2.66669 2.36663C2.10089 2.36663 1.55827 2.59139 1.15819 2.99146C0.758117 3.39154 0.533356 3.93416 0.533356 4.49996V13.8333C0.533356 14.3991 0.758117 14.9417 1.15819 15.3418C1.55827 15.7419 2.10089 15.9666 2.66669 15.9666H12C12.5658 15.9666 13.1084 15.7419 13.5085 15.3418C13.9086 14.9417 14.1334 14.3991 14.1334 13.8333V9.16663C14.1334 8.7248 13.7752 8.36663 13.3334 8.36663C12.8915 8.36663 12.5334 8.7248 12.5334 9.16663V13.8333C12.5334 13.9747 12.4772 14.1104 12.3771 14.2104C12.2771 14.3104 12.1415 14.3666 12 14.3666H2.66669C2.52524 14.3666 2.38958 14.3104 2.28957 14.2104C2.18955 14.1104 2.13336 13.9747 2.13336 13.8333V4.49996C2.13336 4.35851 2.18955 4.22285 2.28957 4.12284C2.38958 4.02282 2.52524 3.96663 2.66669 3.96663H7.33336C7.77518 3.96663 8.13336 3.60845 8.13336 3.16663C8.13336 2.7248 7.77518 2.36663 7.33336 2.36663H2.66669Z"
                    fill="#1677FF"
                />
            </g>
            <defs>
                <clipPath id="clip0_256_8517">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default EditIcon;
